import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import GetAppModal from "@/components/site/GetAppModal";
import CookieBanner from "@/components/site/CookieBanner";
import { AppModalProvider } from "@/context/AppModalContext";
import { trackPageview } from "@/lib/analytics";
import { useUtmCapture } from "@/hooks/useUtm";

function PageviewTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageview(location.pathname + location.search);
    // Scroll to top on route change
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    }
  }, [location.pathname, location.search]);
  return null;
}

export default function Layout() {
  useUtmCapture();
  return (
    <AppModalProvider>
      <PageviewTracker />
      <div className="App min-h-screen flex flex-col bg-white">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <GetAppModal />
        <CookieBanner />
      </div>
    </AppModalProvider>
  );
}
